<template>
  <div class="d-flex align-items-start">
    <!-- For FB apps in development mode may show empty space,
    see info on https://developers.facebook.com/docs/messenger-platform/discovery/send-to-messenger-plugin -->
    <div v-show="facebookPluginLoaded"
         class="fb-send-to-messenger"
         :messenger_app_id="facebookAppId"
         :page_id="facebookPageId"
         color="blue"
         size="standard"
         :data-ref="`${testRef}-${channelId}`">
    </div>
    <spinner v-show="!showRenderError && !facebookPluginLoaded"></spinner>
    <div v-show="showRenderError && !facebookPluginLoaded" class="alert alert-warning" role="alert">
      <span>Send to Messenger button could not be loaded. Possible causes are:</span>
      <ul>
        <li>Adblocker is blocking the button itself or its communication.</li>
        <li>The Facebook Page is not public.</li>
      </ul>
      <span>Test the connection by sending a message to {{facebookPageName}} using <a
        :href="`https://m.me/${facebookPageId}`" target="_blank">Messenger</a>.
        Then go to <router-link :to="{name: 'administration.channel-detail.logs'}">Logs</router-link> to verify the message was received.
      </span>
    </div>
  </div>
</template>

<script>
  import facebookService from '@/services/facebook/facebook.service'
  import Spinner from 'vue-simple-spinner'

  export default {
    components: {
      'spinner': Spinner
    },

    props: ['facebookPageId', 'testRef', 'facebookPageName', 'channelId'],

    data() {
      return {
        facebookAppId: '',
        facebookPluginLoaded: false,
        showRenderError: false
      }
    },

    methods: {
      sendToMessengerRendered() {
        this.facebookPluginLoaded = true
      }
    },

    mounted() {
      setTimeout(() => {
        this.showRenderError = true
      }, 4000)
      facebookService.getAppId()
        .then((appId) => {
          this.facebookAppId = appId
          facebookService.setSendToMessengerPluginRenderedCallback(this.sendToMessengerRendered)
        })
    }
  }
</script>
